/*eslint-disable*/
import React, { useEffect } from 'react'
import AOS from 'aos'

const Privacy = () => {
  useEffect(() => {
    AOS.init({ once: true })
  }, [])

  return (
    <section
      className='mx-auto max-w-6xl px-4 py-8 lg:py-0'
      data-aos='fade'
      data-aos-duration='2000'
    >
      <div className='text-xl text-gray-800'>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h3'>
            OYA! APP Privacy Policy
          </h1>

          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            Safeguarding your Privacy.
          </h4>
          <p className='font-medium leading-loose text-xl text-gray-800'>
            You entrust us with your information when using Oya! We pledge to
            uphold your confidence. Helping you comprehend our privacy practices
            is the first step in doing that. <br />
            This policy succinctly and clearly explains the data we gather, and
            how it is used, and shared. It also highlights the responsibilities
            and demands placed on the website and website owners, mobile apps as
            well as your options with regard to this data.
          </p>
        </div>

        <div className='pb-8 sm:pb-10'>
          <h1 className='font-semibold text-2xl lg:4xl pb-4 md:text-oya-ghana-header-h4'>
            A<span className='text-oya-ghana-green'>.</span> THE USER'S
            ACCEPTANCE OF THIS POLICY
          </h1>
          ​
          <ul className='font-medium leading-loose text-xl text-graypl-5 list-disc marker:text-2xl md:marker:text-4xl marker:text-oya-ghana-green   my-2 mx-5 '>
            <li className=''>
              By using Oya! services (the “Services”) or registering,
              downloading information or entering the Site and/or the App you
              acknowledge that you are or have had the opportunity to become
              aware of this Privacy Policy and Oya! practices described therein,
              including the processing (including collecting, using, disclosing,
              retaining or disposing) of your information under the terms of
              this policy.
            </li>
            <li>
              If you give Oya! any information about another person, you
              guarantee that you have informed them of our privacy statement.
            </li>
          </ul>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            B<span className='text-oya-ghana-green'>.</span> OUR WEBSITE
          </h1>

          <p className='font-medium leading-loose text-xl text-gray-800'>
            This website and its proprietors are proactive when it comes to user
            privacy, making sure that all essential precautions are taken to
            safeguard that privacy throughout user interactions with the website
            and its mobile apps. In terms of user privacy, this website complies
            with all applicable national legislation in Ghana.
          </p>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            C<span className='text-oya-ghana-green'>.</span> WHEN DO WE COLLECT
            INFORMATION?
          </h1>
          <ul className='font-medium leading-loose text-xl text-graypl-5 list-disc marker:text-2xl md:marker:text-4xl marker:text-oya-ghana-green my-2 mx-5'>
            <li className=''>
              You may be requested to give your name, email address, phone
              number, or other data when placing a purchase or registering on
              our site and mobile apps as applicable.
            </li>
            <li>
              Oya! gathers both "Personal Information" and "Anonymous
              Information" from its users and visitors. Your complete name,
              email address, phone number, payment information, login name,
              password, mailing address, IP address, and profile image are
              examples of personal information that can be used to contact or
              identify you. Personal information also includes data that is
              associated with such data. "Anonymous Information" is data that
              cannot be connected to other data that can be used to contact or
              identify you. It also includes passively gathered data regarding
              your use of the Site or the App, such as user statistics, to the
              extent that data is not connected to your Personal Information.
            </li>
          </ul>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            D<span className='text-oya-ghana-green'>.</span> OUR USAGE OF THE
            INFORMATION
          </h1>

          <p className='font-medium leading-loose text-xl text-gray-800'>
            When you register, make a purchase, subscribe to our newsletter,
            fill out a survey, respond to a marketing email, browse our website,
            use our mobile applications, or use specific other site features, we
            may use the information we learn about you in the following ways:
          </p>

          <ul className='font-medium leading-loose text-xl text-gray pl-5 list-disc marker:text-2xl md:marker:text-4xl marker:text-oya-ghana-green '>
            <li className=' '>
              To enhance your experience and enable us to give the kinds of
              information and product options in which you are most interested.
            </li>
            <li>
              Help make our website better so that we can better serve you.
            </li>
            <li>
              In order for us to fulfill your requests for customer service more
              effectively.
            </li>
            <li>
              To handle the administration of a promotion, survey, contest, or
              other similar feature.
            </li>
            <li>To complete your transactions as swiftly as possible.</li>
            <li>To request ratings and reviews for products and services.</li>
            <li>
              To follow up and contact passengers and riders. (live chat, email
              or phone inquiries)
            </li>
            <li>
              Arrange transportation, delivery, and other offers, acquire,
              supply, or facilitate insurance or financing options in
              conjunction with our services.
            </li>
            <li>
              Enable options that let you share information with others, such as
              when you rate & review a driver, recommend Oya! to a friend, or
              share your speed report as well as current location and ETA.
            </li>
            <li>
              Turn on options to customize your Oya! account, including making
              bookmarks for your favorite locations.
            </li>
            <li>
              Perform internal tasks required to deliver our services, such as
              analyzing the use and activity patterns, testing and debugging
              software defects, operational issues, and data analysis.
            </li>
          </ul>
          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            Safety and Security
          </h4>
          <p className='font-medium leading-loose text-xl text-gray-800'>
            We utilize the information you provide to help keep our services
            reliable, secure, and honest. For instance, we gather data from the
            devices of our riders and passengers in order to spot risky driving
            habits like speeding or abrupt braking and acceleration and to
            increase awareness of these habits among our driver partners.
          </p>
          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            Customer support
          </h4>
          <p className='font-medium leading-loose text-xl text-gray-800'>
            In order to help you when you contact our customer support services,
            Oya! utilizes the data we gather (including recordings of customer
            support conversations after notice to you and with your consent)
            including to:
          </p>
          <ul className='font-medium leading-loose text-xl text-gray pl-5 list-disc marker:text-2xl md:marker:text-4xl marker:text-oya-ghana-green '>
            <li className=' '>
              Send your inquiries to the relevant department of customer care
              for immediate resolution.
            </li>
            <li>Investigate and respond to your queries.</li>
            <li>
              Monitor and improve our customer support responsiveness and
              response time.
            </li>
          </ul>
          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            Research and development
          </h4>
          <p className='font-medium leading-loose text-xl text-gray-800'>
            The data we gather may be used for product development, testing,
            research, and analysis. This enables us to create new features and
            products, increase the safety and security of our services, and make
            it easier to implement insurance and financial solutions in
            conjunction with those services.
          </p>

          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            Research and development
          </h4>
          <p className='font-medium leading-loose text-xl text-gray-800'>
            Oya! makes use of the data we gather to facilitate user
            interactions.
          </p>
          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            Communications from Oya!
          </h4>
          <p className='font-medium leading-loose text-xl text-gray-800'>
            Oya! may contact you about products, services, promotions, research,
            surveys, news, updates, and events using the information we have
            collected. The information may also be used by Oya! to administer
            contests, fulfill rewards, and provide you with pertinent
            information about our services and the services of our business
            partners, and this communique will be disseminated using official
            Oya! account.
          </p>
          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            Legal proceedings and requirements
          </h4>
          <p className='font-medium leading-loose text-xl text-gray-800'>
            To investigate or resolve claims or disputes connected to your use
            of Oya! services, or as otherwise permitted by applicable law, we
            may utilize the information we collect. <br /> <br />
            Oya! may also gather information, perhaps including personal
            information, regarding the device you use to access the Site, Apps,
            and/or Services. This data is utilized to identify your device and
            connect it to your account. The sharing of information about your
            device, including limited personal data, IP address, WiFi, and
            location information with a third-party service provider, is done
            for safety, security, performance evaluation of the app or the site,
            customer experience improvement, and fraud protection.
          </p>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            E<span className='text-oya-ghana-green'>.</span> COOKIES AND OTHER
            WEB FILES OR TAGS
          </h1>
          <ul className='font-medium leading-loose text-xl text-graypl-5 list-disc marker:text-2xl md:marker:text-4xl marker:text-oya-ghana-green my-2 mx-5'>
            <li className=''>
              On different pages of our site and sections of our apps, along
              with other files and tags, we employ cookies to give it a pleasing
              visual look and to enable the use of specific services (e.g.
              JavaScript tags). Cookies are made up of tiny text files that are
              kept on your system.
            </li>
            <li>
              The majority of these cookies we use will be removed from your
              computer's hard disk right after your browser session (so-called
              session cookies).
            </li>
            <li>
              Other cookies stay on your device's hard drive and help us
              identify them if you visit our website again in the future
              (so-called persistent cookies). These cookies in particular
              provide us with the ability to improve the usability, efficiency,
              and security of our website. For instance, these files allow
              information to be shown on a specific webpage that is tailored to
              your unique preferences. The lifespan of a cookie-based browser
              session is 18 hours.
            </li>
            <li>
              Clicks and other internet behavior will be tracked by the cookies,
              among other things.
            </li>
            <li>
              In order to differentiate you from other users, the Site and the
              Apps both employ cookies and other local files. In order to learn
              more about how you use the internet generally, Oya! may utilize a
              cookie or configuration file that is saved on your computer's or
              mobile phone's browser or hard disk. The hard disk of your
              computer and/or mobile phone device receives information from
              cookies and other similar files. They assist Oya! in enhancing the
              website and mobile application and providing better, more
              individualized service.
            </li>
          </ul>
          <h4 className='text-gray-800 font-bold mt-2 text-oya-ghana-light-green'>
            They enable Oya! to:
          </h4>
          <ul className='font-medium leading-loose text-xl text-graypl-5 list-disc marker:text-2xl md:marker:text-4xl marker:text-oya-ghana-green my-2 mx-5'>
            <li>
              To do further analytics and determine the size and usage patterns
              of the Oya! audience.
            </li>
            <li>
              To acquire data on your approximate location (such as a city) in
              order to deliver localized content and immediate support in the
              event of an emergency.
            </li>
            <li>
              To keep track of your choices and enable Oya! to tailor the
              website and/or mobile application to your unique needs and the
              device or browser you are now using.
            </li>
            <li>Constantly enhance Oya! Services.</li>
            <li>
              For the purpose of recognizing you when you return to the Site or
              App and to thwart misuse or fraud.
            </li>
            <li>
              The performance or execution of a contract with you (where cookies
              are required as part of the customer journey) or otherwise our
              legitimate interests in a safe and user-friendly presentation of
              our Site and Mobile Apps constitute the legal bases for processing
              the information contained in cookies and other such files or tags.
            </li>
            <li>
              By turning on the browser setting that enables you to deny the
              setting of all or specific cookies, you can prevent cookies.
              Nevertheless, if you choose a setting that is too limiting, you
              might not be able to use all of the Site's and/or App's features.
              The Oya! system will issue cookies when you log on to the Site
              and/or use the Apps unless you have changed the settings on your
              browser to prevent it from accepting cookies. You might want to
              visit{' '}
              <a
                href='http://www.aboutcookies.org/ '
                className='text-oya-ghana-light-green'
              >
                Cookies
              </a>{' '}
              for more details about cookies and how to control them.
            </li>
          </ul>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            F<span className='text-oya-ghana-green'>.</span> CONTACT AND
            COMMUNICATION
          </h1>
          <p>
            Your information will be used by this website and its owners to help
            you with any questions or inquiries you may have and to provide you
            with further information about the products and services they offer.
            This includes the use of your information to sign you up for any
            email newsletter service, or notification services the website and
            its apps run, but only if this was made clear to you and you gave
            your consent when submitting any form to the email process. Or in
            cases when you, the customer, have previously bought from or
            inquired about buying from the business a product or service that
            the email newsletter refers to. The rights you have as a user in
            relation to receiving email marketing messages are not entirely
            covered by this list. Your information is not shared with any
            outside parties.
          </p>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            G<span className='text-oya-ghana-green'>.</span> SOCIAL MEDIA
            PLATFORMS
          </h1>
          <p>
            This website and its owners follow the terms and conditions and
            privacy policies that are specific to each external social media
            platform when communicating, engaging with, and taking other
            activities through those channels.
            <br /> <br />
            Users are urged to utilize social media platforms responsibly and to
            interact with them and engage in other activities with necessary
            care and caution in regards to their own privacy and personal
            information. Neither this website nor its proprietors will ever
            request personal or sensitive information through social networking
            platforms, and they instead urge visitors who want to talk about
            sensitive topics to get in touch with them via traditional lines of
            communication like phone or email using official Oya! account.
            <br /> <br />
            This website may utilize social sharing buttons to enable users to
            share online content straight to the relevant social media platform
            from web pages. Before using such social sharing buttons, users are
            cautioned to use their best judgment and understand that the social
            media platform may monitor and save their request to share a web
            page through their individual social media platform accounts.
          </p>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            H<span className='text-oya-ghana-green'>.</span> INFORMATION
            RETENTION AND DELETION
          </h1>
          <p>
            Unless you ask for the deletion of your information or account, Oya!
            keeps your information as long as your account is active. Even if
            you deactivate your account, there are circumstances in which we may
            continue to keep some information on you as required by law or for
            other reasons as outlined in this section. Unless you request that
            we erase your information or your account, Oya! keeps your
            information while your account is active. On request, Oya! deletes
            or anonymizes your information, subject to the restrictions listed
            below.
            <br /> <br />
            After an account is deleted, Oya! may keep certain information,
            subject to applicable law:
          </p>
          <ul className='font-medium leading-loose text-xl text-gray pl-5 list-disc marker:text-2xl md:marker:text-4xl marker:text-oya-ghana-green '>
            <li>
              If a problem with one of your accounts, such as an unpaid credit
              on your account or an unsettled claim or dispute, remains
              unsolved.
            </li>
            <li>
              If compelled to do so by relevant legislation, in aggregated or
              anonymized form, or both.
            </li>
            <li>
              In order to further its legitimate business objectives, such as
              preventing fraud and boosting user security, Oya! may also keep
              some information on file. For instance, if Oya! closes a user's
              account due to risky behavior or security breaches, Oya! may save
              certain information about that account in order to stop the person
              from creating a new Oya! account in the future.
            </li>
          </ul>
        </div>
        <div className='pb-8 sm:pb-10'>
          <h1 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
            I<span className='text-oya-ghana-green'>.</span> UPDATES TO THIS
            POLICY
          </h1>
          <p>
            This policy may occasionally be updated. If you use our services
            following a change, you agree to the new policy. <br />
            If we make any important changes, we'll let you know about them via
            the Oya! applications or some other channel, like email. You agree
            to our modifications to this policy, to the extent permitted by
            applicable law, by using our services following such notification.
            <br /> <br />
            For the most up-to-date information on our privacy policies, we
            recommend you consult this policy on a regular basis. Also
            accessible for review will be earlier iterations of our privacy
            rules.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Privacy
